import React, {Fragment} from "react";
import "views/Unauthenticated/Registerv2/RegisterV2.css"
import "flag-icon-css/css/flag-icon.css";
import {withRouter} from "react-router-dom";
import InboundTransactionService from "services/Transaction/inbound/InboundTransactionService";
import WelcomeStep from "views/Unauthenticated/Registerv2/Steps/WelcomeStep";
import YesNoQuestionStep from "views/Unauthenticated/Registerv2/Steps/YesNoQuestionStep";
import MsisdnCaptureStep from "views/Unauthenticated/Registerv2/Steps/MsisdnCaptureStep";
import TextCaptureStep from "views/Unauthenticated/Registerv2/Steps/TextCaptureStep";
import DocumentTypeStep from "views/Unauthenticated/Registerv2/Steps/DocumentTypeStep";
import DocumentUploadStep from "views/Unauthenticated/Registerv2/Steps/DocumentUploadStep";
import DocumentDetailCaptureStep from "views/Unauthenticated/Registerv2/Steps/DocumentDetailCaptureStep";
import AddressCaptureStep from "views/Unauthenticated/Registerv2/Steps/AddressCaptureStep";
import DOBCaptureStep from "views/Unauthenticated/Registerv2/Steps/DOBCaptureStep";
import NationalityCaptureStep from "views/Unauthenticated/Registerv2/Steps/NationalityCaptureStep";
import SubmitStep from "views/Unauthenticated/Registerv2/Steps/SubmitStep";
import GenderCaptureStep from "views/Unauthenticated/Registerv2/Steps/GenderCaptureStep";
import HelpStep from "views/Unauthenticated/Registerv2/Steps/HelpStep";
import NotRedeemableStep from "views/Unauthenticated/Registerv2/Steps/NotRedeemableStep";
import EmailCaptureStep from "views/Unauthenticated/Registerv2/Steps/EmailCaptureStep";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import ToastHelper from "utils/ToastHelper";
import UtilityProvince from "domain/Util/UtilityProvince";
import * as AddressUtil from "utils/AddressUtil";
import * as QueryStringUtil from "utils/QueryStringUtil";
import StepQuestion from "components/Step/StepQuestion";
import * as ValidationRule from "utils/ValidationRule";
import IdTypeEnum from "domain/Customer/IdTypeEnum";
import StepLoadingComponent from "components/Step/StepLoadingComponent";
import RegistrationTypeEnum from "domain/Registerv2/RegistrationType";
import ContactDetails from "views/Unauthenticated/Registerv2/Steps/ContactDetails";
import BopCategoryStep from "views/Unauthenticated/Registerv2/Steps/BopCategoryStep";
import RegistrationRequestLimitService from "../../../services/Registration/RegistrationRequestLimitService";
import DocumentInboundLimitUploadStep from "./Steps/DocumentInboundLimitUploadStep";
import S3DocumentTypeEnum from "domain/S3DocumentTypeEnum";
import SelfToSelfLimitService from "../../../services/Limit/SelfToSelfLimitService";
import StopStep from "./Steps/StopStep";
import AdditionalDocumentsUploadStep from "./Steps/AdditionalDocumentsUploadStep";
import TransactingPartnerConfigService from "../../../services/TransactingPartnerConfigService";
import ChatComponent from "../../../components/Chat/ChatComponent";
import SystemConfigService from "../../../services/SystemConfigService";

const StepKeys = {
    WELCOME: "WELCOME",
    // REGISTER_QUESTION: "REGISTER_QUESTION",

    SA_MSISDN_QUESTION: "SA_MSISDN_QUESTION",
    MSISDN_CAPTURE: "MSISDN_CAPTURE",
    EMAIL_CAPTURE: "EMAIL_CAPTURE",

    DOCUMENT_TYPE_SELECTION: "DOCUMENT_TYPE_SELECTION",
    DOCUMENT_UPLOAD_ID: "DOCUMENT_UPLOAD_ID",
    DOCUMENT_UPLOAD_SELFIE: "DOCUMENT_UPLOAD_SELFIE",
    DOCUMENT_DETAILS_CAPTURE: "DOCUMENT_DETAILS_CAPTURE",
    DOCUMENT_LIMIT_UPLOAD: "DOCUMENT_LIMIT_UPLOAD",
    ADDITIONAL_DOCUMENTS_UPLOAD: "ADDITIONAL_DOCUMENTS_UPLOAD",

    PERSONAL_NAME_CAPTURE: "PERSONAL_NAME_CAPTURE",
    PERSONAL_DOB_CAPTURE: "PERSONAL_DOB_CAPTURE",
    PERSONAL_GENDER_CAPTURE: "PERSONAL_GENDER_CAPTURE",
    PERSONAL_NATIONALITY_CAPTURE: "PERSONAL_NATIONALITY_CAPTURE",

    ADDRESS_DETAILS_CAPTURE: "ADDRESS_DETAILS_CAPTURE",
    BOP_CATEGORY: "BOP_CATEGORY",

    SUBMIT: "SUBMIT",
    SUBMIT_SUCCESSFUL: "SUBMIT_SUCCESSFUL",

    INVALID_TOKEN: "INVALID_TOKEN",
    NOT_REDEEMABLE: "NOT_REDEEMABLE",
    STOP: "STOP",

    SPINNER: "SPINNER",
    HELP: "HELP"
};
const StartStep = StepKeys.WELCOME;

const StepConfig = {
    MSISDN_CAPTURE: {nextKey: StepKeys.EMAIL_CAPTURE},
    EMAIL_CAPTURE: {nextKey: StepKeys.DOCUMENT_TYPE_SELECTION},
    DOCUMENT_TYPE_SELECTION: {nextKey: StepKeys.DOCUMENT_LIMIT_UPLOAD},
    DOCUMENT_LIMIT_UPLOAD: {nextKey: StepKeys.DOCUMENT_LIMIT_UPLOAD},
    PERSONAL_NAME_CAPTURE: {nextKey: StepKeys.PERSONAL_DOB_CAPTURE},
    PERSONAL_DOB_CAPTURE: {nextKey: StepKeys.PERSONAL_GENDER_CAPTURE},
    PERSONAL_NATIONALITY_CAPTURE: {nextKey: StepKeys.ADDRESS_DETAILS_CAPTURE},
    ADDRESS_DETAILS_CAPTURE: {nextKey: StepKeys.BOP_CATEGORY},
    BOP_CATEGORY: {nextKey: StepKeys.SUBMIT},
}

const S3_LOGO_URL = "https://sfx-public-bucket.s3-eu-west-1.amazonaws.com/remittance-partner-logos/";


const CHAT_ACTIVE_KEY = 'CUSTOMER_PORTAL_INBOUND_REGISTRATION_CHAT_ACTIVE'

class RegisterV2 extends React.Component {

    static FORWARD = "forward";
    static BACKWARD = "backward";

    constructor(props, context) {
        super(props, context);

        this.token = QueryStringUtil.getQueryStringValue("t");
        this.stepHistory = [];

        this.state = {
            loading: true,
            transactionData: undefined,
            providedFields: {},
            redeemable: false,
            redeemableResponse: undefined,
            currentStep: undefined,
            nextStep: undefined,
            stepDirection: RegisterV2.FORWARD,
            capturedData: {},
            documents: {},
            transactingPartnerConfig: {},

            limitTierSetDocumentsResponse: {},
            isLimitIncreaseRequired: false,
            limitDocuments: {},

            isChatActive: false,

            createConversationError: "",

            viewConversationError: ""

        };

        this.nextStep = this.nextStep.bind(this);
        this.onCapturedDataChanged = this.onCapturedDataChanged.bind(this);
    }

    componentDidMount() {
        NationalityCaptureStep.loadCountryList();
        AddressCaptureStep.loadProvinceList();

        InboundTransactionService.retrieveByToken(this.token).then(response => {

            if (response.id) {
                let providedFields = {};
                response.providedFields.forEach(singleField => {
                    providedFields[singleField.providedFieldName.toUpperCase()] = singleField.requiredFieldValue;
                });

                let capturedData = this.createCapturedData(response, providedFields);
                let newState = {
                    loading: false,
                    transactionData: response,
                    providedFields: providedFields,
                    capturedData: capturedData
                };
                InboundTransactionService.isRedeemable(response.id).then(redeemableResponse => {
                    newState.redeemableResponse = redeemableResponse;

                    if (redeemableResponse["error-code"]) {
                        newState.redeemable = false;
                        newState.currentStep = StepKeys.NOT_REDEEMABLE;
                        ToastHelper.formatError(redeemableResponse);
                    } else {
                        newState.redeemable = redeemableResponse.redeemable;
                        if (redeemableResponse.redeemable === true) {
                            newState.currentStep = StartStep;
                        } else {
                            newState.currentStep = StepKeys.NOT_REDEEMABLE;
                        }
                    }

                    SystemConfigService.retrieveConfigEntryUsingRegisteringPartnerCred(CHAT_ACTIVE_KEY).then(response => {
                        if (response.id) {
                            if (response.value === 'true') {
                                newState.isChatActive = true;
                            }
                        }
                        this.setState(newState, () => this.getConfigByRemittancePartner());
                    })
                });
            } else {
                if (response["error-code"] && response["error-code"] !== "UNAUTHORIZED") {
                    ToastHelper.formatError(response);
                }
                this.setState({
                    loading: false,
                    currentStep: StepKeys.INVALID_TOKEN
                });
            }
        });
    }

    getConfigByRemittancePartner() {
        TransactingPartnerConfigService.retrieveConfigByRemittancePartner(this.state.transactionData.remittancePartner).then(response => {
            if (response.errors) {
                ToastHelper.error(response);
            } else {
                this.setState({
                    transactingPartnerConfig: response
                })
            }
        })
    }

    checkLimitForSelfToSelf(data) {
        if (this.state.transactionData.senderType === 'SELF') {
            let idType = data[RegistrationElements.ID_TYPE];
            let beneficiaryAmount = this.state.transactionData["beneficiaryAmount"];

            SelfToSelfLimitService.checkLimits(idType, beneficiaryAmount).then(response => {
                let selfToSelfLimitCheckResponse = response;
                if (!response.canContinue) {
                    this.checkLimitForNewRegistration(data)

                } else {
                    this.setState({
                        isAdditionalDocumentsRequired: response.hasAdditionalRequirements,
                        additionalDocumentsRequired: response.additionalRequirements,
                        selfToSelfLimitCheckResponse: selfToSelfLimitCheckResponse,
                    }, () => {
                        this.checkLimitForNewRegistration(data);
                    })
                }
            })
        } else {
            this.checkLimitForNewRegistration(data);
        }
    }

    checkLimitForNewRegistration(data) {
        let idType = data[RegistrationElements.ID_TYPE];
        let beneficiaryAmount = this.state.transactionData["beneficiaryAmount"];
        let type = this.state.transactionData["inboundTransactionType"];

        RegistrationRequestLimitService.retrieveForNewRegistration(idType, beneficiaryAmount, type).then(response => {
                this.setState({
                    limitTierSetDocumentsResponse: response,
                    isLimitIncreaseRequired: response["limitIncreaseRequired"],
                    limitRequiredDocumentCount: response["requiredDocuments"].length
                }, () => this.nextStep(StepKeys.DOCUMENT_UPLOAD_ID, data));
            }
        )
    }

    createCapturedData(transactionData, providedFields) {
        let capturedData = {};
        Object.keys(RegistrationElements).forEach(singleElement => {
            capturedData[RegistrationElements[singleElement]] = this.getDefault(RegistrationElements[singleElement], transactionData, providedFields);
        });
        return capturedData;
    }

    getDefault(registrationElement, transactionData = this.state.transactionData, providedFields = this.state.providedFields) {
        switch (registrationElement) {
            case RegistrationElements.CONTEXT:
                return "INBOUND";
            case RegistrationElements.CONTEXT_ID:
                return transactionData.id;
            case RegistrationElements.REGISTRATION_TYPE:
                return RegistrationTypeEnum.NON_FACE_TO_FACE;
            case RegistrationElements.MSISDN:
                return providedFields["BENECELLNO"] || "";
            case RegistrationElements.EMAIL:
                return providedFields["SIKBENEEMAILADDRESS"] || "";
            case RegistrationElements.FIRST_NAME: {
                let firstName = providedFields["BENEFIRSTNAME"] || "";
                let middleName = (providedFields["BENEMIDDLENAME"] || "").trim();
                if (middleName.length > 0) {
                    firstName += " " + middleName;
                }
                return firstName;
            }
            case RegistrationElements.LAST_NAME:
                return providedFields["BENELASTNAME"] || "";
            case RegistrationElements.DOB:
                return providedFields["BENEDATEOFBIRTH"] || "";
            case RegistrationElements.NATIONALITY:
                return providedFields["BENENATIONALITY"] || "";
            case RegistrationElements.STREET_NUMBER: {
                let addressComponents = AddressUtil.splitAddress(providedFields["BENEADDRESS"] || "")
                return addressComponents.streetNumber;
            }
            case RegistrationElements.STREET_NAME: {
                let addressComponents = AddressUtil.splitAddress(providedFields["BENEADDRESS"] || "")
                return addressComponents.streetName;
            }
            case RegistrationElements.TOWN:
            case RegistrationElements.CITY:
                return providedFields["BENECITY"] || "";
            case RegistrationElements.PROVINCE:
                return UtilityProvince.fromIso(providedFields["BENESTATE"] || "");
            case RegistrationElements.POSTAL_CODE:
                return providedFields["BENEZIPCODE"] || "";
            default:
                return "";
        }
    }


    nextStep(nextStepKey, newCapturedData = {}) {

        let capturedData = {
            ...this.state.capturedData,
            ...newCapturedData
        };

        this.stepHistory.push(
            {previous: this.state.currentStep, current: nextStepKey}
        );

        this.setState({
            capturedData: capturedData,
            currentStep: StepKeys.SPINNER,
            nextStep: nextStepKey,
            stepDirection: RegisterV2.FORWARD
        }, this.stopSpinning);
    }

    onHelpClick() {
        this.stepHistory.push(
            {previous: this.state.currentStep, current: StepKeys.HELP}
        );

        this.setState({
            currentStep: StepKeys.HELP
        });
    }

    stopSpinning() {
        setTimeout(() => {
            this.setState({
                currentStep: this.state.nextStep,
                nextStep: undefined
            });
        }, 300);
    }

    backStep() {
        if (this.stepHistory.length > 0) {
            let nextStep = this.stepHistory[this.stepHistory.length - 1].previous;
            this.stepHistory.pop();

            this.setState({
                currentStep: nextStep,
                stepDirection: RegisterV2.BACKWARD
            });
        }
    }

    onCapturedDataChanged(key, value) {
        let capturedData = {
            ...this.state.capturedData,
        };
        capturedData[key] = value;

        this.setState({
            capturedData: capturedData
        });
    }

    render() {
        if (this.state.transactionData) {
            let primaryLogoUrl = S3_LOGO_URL + this.state.transactionData.remittancePartner + "-PRIMARY.png";

            return <Fragment>
                <div className={"inbound_background"}>
                    <div className={"step_content"}>
                        <div className={"step_header"}>
                            <div className={"logo"}>
                                <img src={primaryLogoUrl} alt={this.state.transactionData.remittancePartner}/>
                            </div>
                            {
                                this.state.currentStep !== StepKeys.HELP &&
                                <span className={"step_help"} onClick={() => {
                                    this.onHelpClick(StepKeys.HELP)
                                }}>
                                Help <i className={"fa fa-question-circle"}/>
                            </span>
                            }
                        </div>
                        <div className={"step_card"}>
                            {this.renderContent()}
                        </div>
                        {this.state.isChatActive && <Fragment>
                            {this.state.createConversationError === "" ? <Fragment>
                                    {this.renderChat()}
                                </Fragment>
                                :
                                <Fragment>
                                    {this.renderCreateConversationError()}
                                </Fragment>
                            }
                            {this.state.viewConversationError === "" ? <Fragment>
                                    {this.renderChat()}
                                </Fragment>
                                :
                                <Fragment>
                                    {this.renderViewConversationError()}
                                </Fragment>
                            }
                        </Fragment>
                        }
                    </div>
                </div>
            </Fragment>
        } else {
            return <Fragment>

            </Fragment>
        }
    }

    renderContent() {
        return <Fragment>
            {this.renderStep(this.state.currentStep)}
        </Fragment>
    }

    renderStep(stepKey) {
        if (this.state.loading)
            return <StepLoadingComponent/>

        let stepProps = {
            ...this.state.capturedData,
            key: stepKey,
            onKeyValueChange: this.onCapturedDataChanged.bind(this),
            onBackClick: this.backStep.bind(this),
            stepDirection: this.state.stepDirection,
            transactionData: this.state.transactionData
        };

        let currentStepConfig = StepConfig[stepKey];
        if (currentStepConfig && currentStepConfig.nextKey) {
            stepProps.onNextClick = () => {
                this.nextStep(currentStepConfig.nextKey)
            };
        }

        switch (stepKey) {
            case StepKeys.WELCOME: {
                return <WelcomeStep
                    {...stepProps}
                    transactionData={this.state.transactionData}
                    remittancePartner={this.state.transactionData.remittancePartner}
                    transactingPartnerConfig={this.state.transactingPartnerConfig}
                    onClick={() => {
                        this.nextStep(StepKeys.SA_MSISDN_QUESTION);
                    }}
                />
            }
            case StepKeys.SPINNER: {
                return <StepLoadingComponent/>
            }
            // case StepKeys.REGISTER_QUESTION: {
            //     return <YesNoQuestionStep
            //         {...stepProps}
            //         questionText={"Have you previously received money from " + this.state.transactingPartnerConfig.REMITTANCE_PARTNER_DISPLAY_VALUE + " Money Transfer"}
            //         yesText={"Yes"}
            //         noText={"No"}
            //         onYesClick={() => {
            //             this.props.history.push("/redeem-transaction?t=" + this.token);
            //         }}
            //         onNoClick={() => {
            //             this.nextStep(StepKeys.SA_MSISDN_QUESTION);
            //         }}
            //     />
            // }
            case StepKeys.SA_MSISDN_QUESTION: {
                return <YesNoQuestionStep
                    {...stepProps}
                    questionText={"Do you have a South African mobile number?"}
                    onYesClick={() => {
                        let newData = {};
                        if (this.state.capturedData[RegistrationElements.MSISDN].length === 0) {
                            newData = {[RegistrationElements.MSISDN]: this.getDefault(RegistrationElements.MSISDN)};
                        }
                        this.nextStep(StepKeys.MSISDN_CAPTURE, newData);
                    }}
                    onNoClick={() => {
                        let data = {[RegistrationElements.MSISDN]: ""};
                        this.nextStep(StepKeys.EMAIL_CAPTURE, data);
                    }}
                />
            }
            case StepKeys.MSISDN_CAPTURE: {
                return <MsisdnCaptureStep
                    {...stepProps}
                    value={this.state.capturedData[RegistrationElements.MSISDN]}
                    onChange={(value) => {
                        this.onCapturedDataChanged(RegistrationElements.MSISDN, value);
                    }}
                />
            }
            case StepKeys.EMAIL_CAPTURE: {
                return <EmailCaptureStep
                    {...stepProps}
                    required={this.state.capturedData[RegistrationElements.MSISDN].length === 0}
                    onChange={(value) => {
                        this.onCapturedDataChanged(RegistrationElements.EMAIL, value);
                    }}
                />
            }
            case StepKeys.DOCUMENT_TYPE_SELECTION: {
                return <DocumentTypeStep
                    {...stepProps}
                    onNextClick={(data) => {
                        this.checkLimitForSelfToSelf(data)
                    }}
                />
            }
            case StepKeys.DOCUMENT_UPLOAD_ID: {
                return this.renderDocumentStep(stepProps, RegistrationElements.ID_DOCUMENT, StepKeys.DOCUMENT_UPLOAD_SELFIE);
            }
            case StepKeys.DOCUMENT_UPLOAD_SELFIE: {
                let nextStep = StepKeys.DOCUMENT_DETAILS_CAPTURE;
                if (this.state.isLimitIncreaseRequired) {
                    nextStep = StepKeys.DOCUMENT_LIMIT_UPLOAD
                } else if (this.state.isAdditionalDocumentsRequired) {
                    nextStep = StepKeys.ADDITIONAL_DOCUMENTS_UPLOAD
                }
                return this.renderDocumentStep(stepProps, RegistrationElements.SELFIE_DOCUMENT, nextStep);
            }
            case StepKeys.DOCUMENT_LIMIT_UPLOAD: {
                let nextStep = StepKeys.DOCUMENT_DETAILS_CAPTURE;
                if (this.state.isAdditionalDocumentsRequired) {
                    nextStep = StepKeys.ADDITIONAL_DOCUMENTS_UPLOAD;
                }
                return <DocumentInboundLimitUploadStep
                    {...stepProps}
                    limitDocuments={this.state.limitDocuments}
                    requiredDocuments={this.state.limitTierSetDocumentsResponse["requiredDocuments"]}
                    onNextClick={(limitDocuments) => {
                        this.setState({
                            limitDocuments: limitDocuments
                        }, () => this.nextStep(nextStep, {}));
                    }}
                    onBackClick={(limitDocuments) => {
                        this.setState({
                            limitDocuments: limitDocuments
                        }, () => this.backStep());
                    }}
                />
            }
            case StepKeys.ADDITIONAL_DOCUMENTS_UPLOAD: {
                return <AdditionalDocumentsUploadStep
                    {...stepProps}
                    additionalDocuments={this.state.additionalDocuments}
                    requiredDocuments={this.state.additionalDocumentsRequired}
                    onNextClick={(additionalDocuments) => {
                        this.setState({
                            additionalDocuments: additionalDocuments
                        }, () => this.nextStep(StepKeys.DOCUMENT_DETAILS_CAPTURE, {}));
                    }}
                    onBackClick={(additionalDocuments) => {
                        this.setState({
                            additionalDocuments: additionalDocuments
                        }, () => this.backStep());
                    }}
                />
            }
            case StepKeys.DOCUMENT_DETAILS_CAPTURE: {
                return <DocumentDetailCaptureStep
                    {...stepProps}
                    onNextClick={(documentDetails) => {
                        this.nextStep(StepKeys.PERSONAL_NAME_CAPTURE, documentDetails);
                    }}
                />
            }
            case StepKeys.PERSONAL_NAME_CAPTURE: {
                return <TextCaptureStep
                    {...stepProps}
                    questionText={"Please confirm your first and last names:"}
                    config={
                        [
                            {
                                field: RegistrationElements.FIRST_NAME,
                                questionText: "First Name",
                                placeholder: "eg. John",
                                value: this.state.capturedData[RegistrationElements.FIRST_NAME],
                                yupRule: ValidationRule.getAlphaSpaceValidator("First Name", true)
                            },
                            {
                                field: RegistrationElements.LAST_NAME,
                                questionText: "Last Name",
                                placeholder: "eg. Snow",
                                value: this.state.capturedData[RegistrationElements.LAST_NAME],
                                yupRule: ValidationRule.getAlphaSpaceValidator("Last Name", true)
                            }
                        ]
                    }
                />
            }
            case StepKeys.PERSONAL_DOB_CAPTURE: {
                return <DOBCaptureStep
                    {...stepProps}
                    questionText={"Please confirm your date of birth:"}
                    value={this.state.capturedData[RegistrationElements.DOB]}
                    onChange={(value) => {
                        this.onCapturedDataChanged(RegistrationElements.DOB, value);
                    }}
                    readOnly={this.state.capturedData[RegistrationElements.ID_TYPE] === IdTypeEnum.SA_ID}
                />
            }
            case StepKeys.PERSONAL_GENDER_CAPTURE: {
                return <GenderCaptureStep
                    {...stepProps}
                    value={this.state.capturedData[RegistrationElements.GENDER]}
                    readOnly={this.state.capturedData[RegistrationElements.ID_TYPE] === IdTypeEnum.SA_ID}
                    onNextClick={(gender) => {
                        let data = {[RegistrationElements.GENDER]: gender};
                        this.nextStep(StepKeys.PERSONAL_NATIONALITY_CAPTURE, data);
                    }}
                />
            }
            case StepKeys.PERSONAL_NATIONALITY_CAPTURE: {
                return <NationalityCaptureStep
                    {...stepProps}
                    onNextClick={(nationality) => {
                        let data = {[RegistrationElements.NATIONALITY]: nationality};
                        this.nextStep(StepKeys.ADDRESS_DETAILS_CAPTURE, data);
                    }}
                />
            }
            case StepKeys.ADDRESS_DETAILS_CAPTURE: {
                return <AddressCaptureStep
                    {...stepProps}
                />
            }
            case StepKeys.BOP_CATEGORY: {
                return <BopCategoryStep
                    {...stepProps}
                    onDeclarationSigned={(version) => {
                        this.onCapturedDataChanged('reporting-declaration', {
                            'signed': 'true',
                            'version': version
                        })
                        let capturedData = this.state.capturedData;
                        capturedData[RegistrationElements.REPORTING_DECLARATION_SIGNED] = true;
                        capturedData[RegistrationElements.REPORTING_DECLARATION_VERSION] = version;
                        this.setState({
                            capturedData: capturedData
                        });
                    }}
                    transactionAmount={this.state.transactionData.beneficiaryAmount}
                />
            }
            case StepKeys.SUBMIT: {
                return <SubmitStep
                    limitTierSetDocumentsResponse={this.state.limitTierSetDocumentsResponse}
                    limitDocuments={this.state.limitDocuments}
                    additionalDocuments={this.state.additionalDocuments}
                    onBackClick={this.backStep.bind(this)}
                    capturedData={this.state.capturedData}
                    onSubmitSuccessful={() => {
                        this.nextStep(StepKeys.SUBMIT_SUCCESSFUL)
                    }}
                />
            }
            case StepKeys.SUBMIT_SUCCESSFUL: {
                return this.renderSubmitSuccessful();
            }
            case StepKeys.HELP: {
                return <HelpStep
                    {...stepProps}
                    emailAddress={this.state.transactingPartnerConfig["EMAIL_ADDRESS"]}
                />
            }
            case StepKeys.INVALID_TOKEN: {
                return this.renderInvalidTokenStep();
            }
            case StepKeys.NOT_REDEEMABLE: {
                return <NotRedeemableStep
                    {...stepProps}
                    redeemableResponse={this.state.redeemableResponse}
                    emailAddress={this.state.transactingPartnerConfig["EMAIL_ADDRESS"]}
                />
            }
            case StepKeys.STOP: {
                return <StopStep
                    {...stepProps}
                    stopMessage={this.state.stopMessage}
                    emailAddress={this.state.transactingPartnerConfig["EMAIL_ADDRESS"]}
                />
            }
            default: {
                return <Fragment>
                    <StepQuestion>
                        An unexpected error occurred.
                    </StepQuestion>
                </Fragment>
            }
        }
    }

    renderDocumentStep(stepProps, registrationElement, nextStep) {
        return <DocumentUploadStep
            {...stepProps}
            registrationElement={registrationElement}
            s3DocumentType={S3DocumentTypeEnum.REGISTRATION_DOCUMENT}
            accept={DocumentUploadStep.ACCEPT_IMAGES}
            selectedDocument={this.state.documents[registrationElement]}
            onDocumentSelected={(selectedDocument => {
                let documents = {...this.state.documents};
                documents[registrationElement] = selectedDocument;
                this.setState({documents: documents});
            })}
            onNextClick={(s3MetaDataId) => {
                let data = {[registrationElement]: s3MetaDataId};
                this.nextStep(nextStep, data);
            }}
        />
    }

    renderSubmitSuccessful() {
        return <Fragment>
            <StepQuestion>
                That's all!
                <br/><br/>
                Thank you for providing us with your information.
                <br/><br/>
                You will receive further communication from us regarding progress of your transaction shortly.
            </StepQuestion>
        </Fragment>
    }

    renderInvalidTokenStep() {
        return <Fragment>
            <StepQuestion>
                It appears this link is not valid or has expired.
                <br/><br/>
                Please contact us for further assistance.
                <br/><br/>
                <ContactDetails
                    emailAddress={this.state.transactingPartnerConfig["EMAIL_ADDRESS"]}
                />
            </StepQuestion>
        </Fragment>
    }

    renderChat() {
        return <Fragment>
            <div className={"chat-with-us-text"}>
                <span>Click below to chat with us!</span>
            </div>
            <ChatComponent
                customType={''}
                context={[{resourceType: 'INBOUND_TRANSACTION_ID', resourceId: this.state.transactionData.id}]}
                onConversationFailedToCreate={(error) => {
                    this.setState({
                        createConversationError: error.errors
                    });
                }}
                onFailedToLoadUser={(error) => {
                    this.setState({
                        viewConversationError: error.errors
                    });
                }}
            />
        </Fragment>
    }

    renderCreateConversationError() {
        return <Fragment>
            <div className={"error-pop-up"}>
                <span>{"There was an issue connecting you to a consultant."}</span>
                <br/>
                <span>{"Please refresh and try again."}</span>
            </div>
        </Fragment>
    }

    renderViewConversationError() {
        return <Fragment>
            <div className={"error-pop-up"}>
                <span>{"There was an issue connecting you to a consultant."}</span>
                <br/>
                <span>{"Please refresh and try again."}</span>
            </div>
        </Fragment>
    }
}

export default withRouter(RegisterV2);